import type { AgentLogsQueryParams } from '../mapAgentLogsFiltersToQueryParams';

import { listAgentExecutions } from '~/api/agentLogs';
import type { AgentExecutionListItem } from '~/api/agentLogs/types';

type ResolveAgentLogListItemParams = {
  agentExecutionKey: string;
  listItems: AgentExecutionListItem[];
  realm: string;
  environment: string;
  queryParams: AgentLogsQueryParams;
};

export function findAgentLogListItem(
  listItems: AgentExecutionListItem[],
  agentExecutionKey: string
): AgentExecutionListItem | undefined {
  return listItems.find(item => item.agentExecutionKey === agentExecutionKey);
}

export async function resolveAgentLogListItem({
  agentExecutionKey,
  listItems,
  realm,
  environment,
  queryParams
}: ResolveAgentLogListItemParams): Promise<AgentExecutionListItem | null> {
  const cached = findAgentLogListItem(listItems, agentExecutionKey);
  if (cached) {
    return cached;
  }

  const { dateFrom, dateTo } = queryParams;
  const result = await listAgentExecutions({
    realm,
    environment,
    filters: { agentExecutionKey },
    dateFrom,
    dateTo,
    limit: 1,
    order: 'descending'
  });

  return result.items[0] ?? null;
}
